import { type IKeyValueStorage, KeyValueStorage } from '@walletconnect/keyvaluestorage'

export const createWalletConnectStorage = (): IKeyValueStorage => {
  let storage: KeyValueStorage | undefined

  const run = async <T>(
    operation: keyof IKeyValueStorage,
    call: (storage: KeyValueStorage) => Promise<T>
  ): Promise<T> => {
    try {
      // Config is also created during SSR; defer storage initialization until WalletConnect uses it.
      storage ??= new KeyValueStorage()
      return await call(storage)
    } catch (error) {
      if (error instanceof Error) throw error
      throw new Error(`WalletConnect storage ${operation}: IndexedDB rejected without an error`, { cause: error })
    }
  }

  return {
    getKeys: () => run('getKeys', (storage) => storage.getKeys()),
    getEntries: <T>() => run('getEntries', (storage) => storage.getEntries<T>()),
    getItem: <T>(key: string) => run('getItem', (storage) => storage.getItem<T>(key)),
    setItem: <T>(key: string, value: T) => run('setItem', (storage) => storage.setItem(key, value)),
    removeItem: (key: string) => run('removeItem', (storage) => storage.removeItem(key)),
  }
}
